namespace SSi.Blazor.Common.Shared.Services.OfflineState {
    // ReSharper disable once InconsistentNaming
    declare var DotNet: any;

    async function dispatchOfflineStateChange(dotnetHelper, offline: boolean): Promise<void> {
        await dotnetHelper.invokeMethodAsync("OfflineStateChange", offline);
    }

    //https://caniuse.com/#feat=online-status

    export function getOnline(): boolean {
        return navigator.onLine;
    };

    function gotOnline(dotnetHelper) {
        dispatchOfflineStateChange(dotnetHelper, false);
    }

    function gotOffline(dotnetHelper) {
        dispatchOfflineStateChange(dotnetHelper, true);
    }

    //called directly
    export function setupEventListener(dotnetHelper) {
        window.addEventListener("offline", function (e) { gotOffline(dotnetHelper); });
        window.addEventListener("online", function (e) { gotOnline(dotnetHelper); });
    }

}

